import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface PermissaoInfo {
  nome: string;
  habilitado: boolean;
  visivel: boolean;
  tipo: string;
}
export interface ComponenteDTO {
  nome: string;
  tipo: string;
  habilitado: boolean;
  visivel: boolean;
}

export interface ProgramaDTO {
  id: number;
  nome: string;
  componentes: ComponenteDTO[];
}

export interface PerfilDTO {
  id: number;
  nome: string;
  programas: ProgramaDTO[];
}

export interface PerfilRequestDTO {
  nome: string;
  programas: ProgramaPerfilDTO[];
}

export interface ProgramaPerfilDTO {
  programaId: number;
  nome?: string;
  componentes: ComponentePerfilDTO[];
}

export interface ComponentePerfilDTO {
  nome: string;
  tipo: string;
  habilitado: boolean;
  visivel: boolean;
}

export interface PerfilUsuarioDTO {
  id: number;
  usuarioId: number;
  perfilId: number;
  programas: ProgramaDTO[];
}

@Injectable({
  providedIn: 'root'
})
export class PerfilService {

  constructor(private http: HttpClient) { }

  // ========== PERFIL ==========
  listarTodos(): Observable<PerfilDTO[]> {
    return this.http.get<PerfilDTO[]>('/perfis');
  }

  buscarPorId(id: number): Observable<PerfilDTO> {
    return this.http.get<PerfilDTO>(`/perfis/${id}`);
  }

  criar(perfil: PerfilRequestDTO): Observable<PerfilDTO> {
    return this.http.post<PerfilDTO>('/perfis', perfil);
  }

  atualizar(id: number, perfil: PerfilRequestDTO): Observable<PerfilDTO> {
    return this.http.put<PerfilDTO>(`/perfis/${id}`, perfil);
  }

  deletar(id: number): Observable<void> {
    return this.http.delete<void>(`/perfis/${id}`);
  }

  // ========== PERFIL USUARIO ==========
  vincularUsuario(usuarioId: number, perfilId: number): Observable<PerfilUsuarioDTO> {
    return this.http.post<PerfilUsuarioDTO>('/perfis/vincular-usuario', {
      usuarioId,
      perfilId
    });
  }

  desvincularUsuario(usuarioId: number, perfilId: number): Observable<void> {
    return this.http.delete<void>('/perfis/desvincular-usuario', {
      body: { usuarioId, perfilId }
    });
  }

  listarPerfisPorUsuario(usuarioId: number): Observable<PerfilUsuarioDTO[]> {
    return this.http.get<PerfilUsuarioDTO[]>(`/perfis/usuario/${usuarioId}`);
  }

  buscarPermissoesUsuario(usuarioId: number): Observable<ProgramaDTO[]> {
    return this.http.get<ProgramaDTO[]>(`/perfis/usuario/${usuarioId}/permissoes`);
  }
}